import { EMPTY_OBJECT } from '../../constants/common'
import { postApi } from '../../utils/api'

export function resetSearchFilterState({ entity, sub }) {
  return postApi({
    data: EMPTY_OBJECT,
    endpoint: `idwell-api/api/v3/table/filter-states/${entity.plural}/${sub}/reset/`,
  })
}
